<template>
  <div>
    <tabs-mobile
      :value="currentTab"
      @input="changedTab"
    >
      <b-tab-item value="manual">
          <template #header>
            <span>
              Manual
              <badge-default
                v-if="manualFollowUps.order.length"
                :count="manualFollowUps.order.length"
              ></badge-default>
            </span>
          </template>

        <app-loading-section :loading="pageLoading">
          <template v-if="manualFollowUps.order.length">
            <lazy-render
              v-for="recordId in manualFollowUps.order"
              :key="recordId"
              :min-height="122"
              :unrender="true"
            >
              <section-box class="mb-100">
                <mobile-record-item
                  :record="manualFollowUps.items[recordId]"
                  show-next-contact
                  is-in-box
                ></mobile-record-item>
              </section-box>
            </lazy-render>
          </template>

          <section-box v-else>
            <div class="follow_up--empty">
              <h4 class="follow_up_menu--empty--heading">No Manual Follow Ups</h4>
              <p class="follow_up_menu--empty--message">Any leads you have place in follow up statuses and not in
                automated follow up sequence will show up here.</p>
            </div>
          </section-box>

          <div v-if="!loadingMoreRecords && hasMoreRecordsToLoad" class="flex flex-centered my-200">
            <button-outlined size="" @click="loadMoreRecords">Load More Records</button-outlined>
          </div>
        </app-loading-section>
      </b-tab-item>

      <b-tab-item value="automated" label="Automated">
          <template v-if="automatedFollowUps.order.length">
            <lazy-render
              v-for="recordId in automatedFollowUps.order"
              :key="recordId"
              :min-height="122"
              :unrender="true"
            >
              <section-box class="mb-100">
                <mobile-record-item
                  :record="automatedFollowUps.items[recordId]"
                  show-next-contact
                  is-in-box
                ></mobile-record-item>
              </section-box>
            </lazy-render>
          </template>

          <section-box v-else>
            <div class="follow_up--empty">
              <h4 class="follow_up--empty--heading">No Automated Follow Ups</h4>
              <p class="follow_up_menu--empty--message">Any leads placed in automated follow up sequence with follow up statuses will show up here.</p>
            </div>
          </section-box>

        <div v-if="!loadingMoreRecords && hasMoreRecordsToLoad" class="flex flex-centered my-200">
          <button-outlined size="" @click="loadMoreRecords">Load More Records</button-outlined>
        </div>
      </b-tab-item>
    </tabs-mobile>
  </div>
</template>

<script>
import MobileStatusSection from "../../components/MobileStatusSection";
import TabsMobile from "../../../../components/tab/TabsMobile";
import LazyRender from "../../../../components/LazyRender";
import MobileRecordItem from "../../components/MobileRecordItem";

export default {
  name: "FollowUpPipelineMobile",
  components: {MobileRecordItem, LazyRender, TabsMobile, MobileStatusSection},
  data() {
    return {
      pageLoading: true,
      loadingMoreRecords: false,
    };
  },
  computed: {
    currentTab() {
      return this.$store.getters["followUpState/activeTab"];
    },
    hasMoreRecordsToLoad() {
      return this.$store.getters["followUpState/hasMoreRecordsToLoad"];
    },
    manualFollowUps() {
      return this.$store.getters["recordsInManualFollowUp/records"];
    },
    automatedFollowUps() {
      return this.$store.getters["recordsInAutomatedFollowUp/records"];
    },
  },
  created() {
    this.changedTab("manual");
  },
  destroyed() {
    this.$store.dispatch("followUpState/tearDown");
  },
  methods: {
    changedTab(newTab) {
      this.activeItemIndex = null;
      this.pageLoading = true;

      return this.$store.dispatch("followUpState/activeTab", newTab).then(() => {
        this.pageLoading = false;
      });
    },
    loadMoreRecords() {
      this.loadingMoreRecords = true;

      if (this.currentTab === "manual") {
        return this.$store.dispatch("recordsInManualFollowUp/loadMoreRecords")
          .finally(() => {
            this.loadingMoreRecords = false;
          });
      }
      if (this.currentTab === "automated") {
        return this.$store.dispatch("recordsInAutomatedFollowUp/loadMoreRecords")
          .finally(() => {
            this.loadingMoreRecords = false;
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.record_count {
  margin-right: 12px;

  span {
    flex: none;
    padding: 2px 8px 2px 0;
    border-right: 2px solid $borderDark;
    color: $text-muted;
  }
}

.follow_up_menu {
  &--empty {
    padding: 8px;
    line-height: 1.2;

    &--heading {
      margin-bottom: 8px;
    }
  }
}

.follow_up--empty {
  padding: 2rem 10px;
  font-style: italic;
  text-align: center;

  &--heading {
    margin-bottom: 6px;
    font-size: 1.125rem;
    color: $text-muted;
  }

  &--message {
    color: $text-light;
    line-height: 1.4;
  }
}

.follow_up--load_more_button {
  margin-top: 1rem;
}

</style>
